import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';
import { SendType } from 'interfaces';

export type PushHistory = {
  push_history_id?: number; // 푸시 알림 내역 idx
  push_history?: { [key: string]: Record<string, any> }; // 푸시 전송 알림 내역
  type?: (typeof SendType)[keyof typeof SendType];
  created_at?: number; // 생성일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] PushHistory
   * --
   */
  getPushHistories: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GET_PUSH_HISTORIES, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] PushHistory
   * --
   */
  getPushHistory: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_PUSH_HISTORY, {
        push_history_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] PushHistory
   * --
   */
  createPushHistory: async (body: PushHistory) => {
    try {
      const res = await $http.post(APIConstant.CREATE_PUSH_HISTORY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] PushHistory
   * --
   */
  updatePushHistory: async (body: PushHistory) => {
    try {
      const { push_history_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_PUSH_HISTORY, {
        push_history_id: push_history_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] PushHistory
   * --
   */
  deletePushHistory: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_PUSH_HISTORY, {
        push_history_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
